@let hideAside = hideAside$ | ngrxPush;
@let selectedDownload = selectedDownload$ | ngrxPush;
@let shouldDisplayDetailLink = shouldDisplayDetailLink$ | ngrxPush;
<dacks-content #dacksContent padding="none">
  <section class="py-6 md:px-6">
    <div class="flex justify-center px-8 md:px-0">
      <dackl-tabs
        class="w-full"
        [navigationItems]="navigationItems"
        [tabPanel]="tabPanel"
        breakpoint="sm"
        lightBackground
      ></dackl-tabs>
    </div>
    <mat-tab-nav-panel
      #tabPanel
      class="bg-white p-6 md:rounded-e-lg md:rounded-es-lg shadow-card"
    >
      <router-outlet></router-outlet>
    </mat-tab-nav-panel>
  </section>

  <footer-spacing type="content" />

  <dacks-content-right-aside [open]="!hideAside" slot="right-aside" [heading]="selectedDownload ? selectedDownload.displayTitle : 'Kein Download ausgewählt'" size="medium">
        @if (selectedDownload) {
          <div class="flex flex-col gap-4">
            <download-info-card
              [downloadInformation]="selectedDownload"
              [enableHorizontalDisplay]="false"
            ></download-info-card>

            @if (shouldDisplayDetailLink) {
              <p class="flex justify-end">
                <a
                  #detailLink
                  mat-button
                  color="link-light"
                  [routerLink]="selectedDownload.detailUrl"
                >
                  <span>Detailseite aufrufen</span>
                  <mat-icon
                    class="order-last"
                    svgIcon="sli-pfeil-rechts-20"
                  ></mat-icon>
                </a>
              </p>
            }
          </div>
        } @else {
          <dackl-empty-state image="no-documents" size="XS">
            <p class="text-center">
              Damit Ihnen weitere Informationen zu einem Download angezeigt
              werden können, wählen Sie bitte einen Download aus der Liste
              aus.
            </p>
          </dackl-empty-state>
        }
        <footer-spacing type="aside" />
  </dacks-content-right-aside>
</dacks-content>
